<template>
    <div>
        <HeadCommon></HeadCommon>
        <div class="main">
            <div class="head_bg">
                <img src="../img/contact_us-bg.png" alt="">
                <div class="text">
                    <p style="color: #fff;">产品与服务</p>
                    <span></span>
                </div>
            </div>
            <div class="container product">
                <div class="left_tab">
                    <div class="item_box" v-for="(item, i) in tabList" :key="item.id">

                        <div class="item" :class="{ active: tabIndex === i }" @click="toggleSubMenu(i, item.id, item.type)">
                            <p>{{ item.title }}</p>
                        </div>
                        <div class="children" v-show="tabIndex === i">
                            <div class="li" v-for="(childItem, index) in tabList.list" :key="childItem.id"
                                :class="{ active: childrenIndex === index }"
                                @click="selectChild(index, childItem.id, childItem.type)" ref="dynamicLiElement">
                                <p>{{ childItem.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div >
                    <div>
                        <div v-show="childrenIndex == 0" >
                            <div  v-if="type === 1">
                               <div >
                                    <div >
                                        <p>{{ name }}</p>
                                    </div>
                                    <div></div>
                                    <p v-html="article">
                                    </p>
                                </div>
                            </div>
                            <div class="course_cases" v-else>
                                <div class="list">
                                    <div class="item" v-for="item in PageInfoList" :key="item.id"
                                        @click="getIndustryListInfo(item.id)">
                                        <div >
                                            <img :src="item.img" alt="">
                                        </div>
                                        <div  class="name">
                                            {{ item.title }}
                                        </div>
                                        <div class="info">
                                            <p>{{ item.left_text }}</p>
                                            <span>{{ item.right_text }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="childrenIndex !== 0" >
                            <div >
                                
                                <div  v-if="type === 1">
                                    <div >
                                        <p>{{ name }}</p>
                                    </div>
                                    <p v-html="article"></p>
                                </div>
                                
                                <div class="course_cases" v-else>
                                    <div class="list">
                                        <div class="item" v-for="item in PageInfoList" :key="item.id"
                                            @click="getIndustryListInfo(item.id)">
                                            <div class="img">
                                                <img :src="item.img" alt="">
                                            </div>
                                            <div class="name">
                                                {{ item.title }}
                                            </div>
                                            <div class="info">
                                                <p>{{ item.left_text }}</p>
                                                <span>{{ item.right_text }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                   
                
                <!-- <div class="right_box">
                     课程资源制作
                    <div v-show="tabIndex == 0">
                        <div class="course_introduction-box">
                            <div v-show="childrenIndex == 0" class="course_introduction">
                                <div class="item brief">
                                    <div class="l-title">
                                        <p>课程资源制作简介</p>
                                    </div>
                                    <p>公司拥有资深的在线教育服务团队，可以为用户提供全过程的咨询、建议和覆盖整个课程制作周期的品质监控工作。围绕在线教学的需要，采用先进的信息化试听设备，为用户提供多样化的在线教学资源制作服务，包括在线教学视频制作，宣传片制作，二维、三维动画制作，VR和3D视频制作。满足慕课、一流本科课程、课程思政、资源库、微课、科普视频等各类在线教学资源建设需要。
                                    </p>
                                </div>
                                <div class="item process">
                                    <div class="l-title">
                                        <p>课程资源制作的服务流程</p>
                                    </div>
                                    <div class="list">
                                        <div class="item" v-for="(item, index) in processList" :key="index">
                                            <div class="index">{{ index + 1 }}</div>
                                            <div class="icon">
                                                <img :src="`../img/${item.icon}`" alt="">
                                            </div>
                                            <div class="text">
                                                <p :class="{ active: i == 0 }" v-for="(e, i) in item.text" :key="e">{{ e }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item advantage">
                                    <div class="l-title">
                                        <p>课程资源制作的五个特点</p>
                                    </div>
                                    <div class="list">
                                        <div class="item" v-for="e in advantageList" :key="e">
                                            <div class="title">
                                                <p>{{ e.title }}</p>
                                            </div>
                                            <span>{{ e.brief }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="childrenIndex == 1" class="course_cases">
                            <div class="list">
                                <div class="item" v-for="i in 10" :key="i">
                                    <div class="img">
                                        <img src="../img/course.png" alt="">
                                    </div>
                                    <div class="name">
                                        影墨教育课程资源制作{{ i + 1 }}
                                    </div>
                                    <div class="info">
                                        <p>讲师：嘉士利</p>
                                        <span>27分13秒</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    虚拟仿真
                    <div v-show="tabIndex == 1">
                        <div v-show="childrenIndex == 0" class="software">
                            <div class="item">
                                <div class="l-title">
                                    <p>1、3D仿真/内容定制</p>
                                </div>
                                <img src="../img/r1.png" alt="">
                                <p> 虚拟（Virtual
                                    Reality），仿真（simulation），或称为模拟现实，就是用一个虚拟系统模仿另一个真实系统的技术。虚拟仿真依托计算机，可以通过人的视觉、触觉、听觉等进行现实情况的再现。其逼真性和实时交互性为虚拟仿真资源的本质。
                                    虚拟仿真实验教学是高等教育信息化建设和实验教学示范中心建设的重要内容，是学科专业与信息技术深度融合的产物，是培养学生的动手能力和创新能力的实验教学，是从理论走向实践的一种自主构建教学下的高效教育模式。深化实验教学改革、深化实验教学改革、加强实践教学环节是国家实施“素质教育”与“质量工程”、全面提高教育质量的重要环节。在实际的教学工作中，很多实验和实训有一定限制，导致学生无法讲课堂上学到的理论知识与实际相结合
                                    1、因为时间、地域、环境的限制，如极地取水，恶略天气下展开的操作，地下勘探等
                                    2、成本高、资源消耗大：如助产，综合性手术，治理沙漠等现实无法满足
                                    3、大型实验实训现场如高铁、飞机、矿山、航天实训等
                                    公司通过三维虚拟仿真定制开发技术，将虚拟仿真应用在教育教学中不同专业、不同实验等方面。使人们能沉浸其中，出入自然，形成具有交互效能多维化的信息环境。在项目的整个开发阶段，提供专业的需求定制服务研发部团队会对于整体设计、模型、场景等方面，提根据客户需求，提供整体化解决方案，打造先进的教育教学方法，成熟的评价体系，以及对传统教学方法进行延伸，对传统课堂的教学方法和教学效果极大地提升可以满足甲方需求实现定制开发；
                                </p>
                            </div>
                            <div class="item">
                                <div class="l-title">
                                    <p>2、VR仿真</p>
                                </div>
                                <img src="../img/r2.png" alt="">
                                <p> 通过VR技术制作的虚拟仿真软件依托计算机，可以通过人的视觉、触觉、听觉等进行现实情况的再现。其逼真性和实时交互性为虚拟仿真资源的本质。
                                    虚拟仿真可以应用在教育教学中不同专业、不同实验等方面。使人们能沉浸其中，出入自然，形成具有交互效能多维化的信息环境。虚拟仿真区别于视频等其他教学资源的特点在于：仿真性、虚幻性、交互性、沉浸性。
                                    仿真性
                                    一方面，虚拟环境给人的的各种感觉与所模拟的客观世界非常相像，一切感觉如同在真实世界一样；另一方面，当人以自然的行为作用于虚拟环境时，环境做出的反应也符合客观世界的有关规律。例如，当给虚幻物体一个作用力，该物体的运动就会符合力学定律，会沿着力的方向产生相应的加速度，当它遇到障碍物时，会被阻挡。
                                    虚幻性
                                    既可以模拟客观世界中以前存在过的或是现在真实存在的环境，也可模拟出客观世界中当前并不存在的但将来可能出现的环境，还可模拟客观世界中并不会存在的而仅仅属于人们幻想的环境。
                                    交互性
                                    虚拟仿真系统中，不仅环境能够作用于人，人也可以对环境进行控制，而且人是以近乎自然的行为（自身的语言、肢体的动作等）进行控制的，虚拟环境还能够对人的操作予以实时的反应。
                                    沉浸性
                                    虚拟仿真系统中，使用者可获得视觉、听觉、嗅觉、触觉、运动感觉等多种感知，从而获得身临其境的感受。理想的虚拟仿真系统应该具有能够给人所有感知信息的功能。</p>
                            </div>
                        </div>
                        <div v-show="childrenIndex == 1" class="hardware">
                            <div class="item">
                                <div class="l-title">
                                    <p>1、HTC\一体机</p>
                                </div>
                                <div class="flex">
                                    <div class="item flex1">
                                        <img src="../img/j1.png" alt="">
                                        <p>Pico neo3 一体机</p>
                                    </div>
                                    <div class="item flex1 ml20">
                                        <img src="../img/j2.png" alt="">
                                        <p>HTC VIVO PRO 头显</p>
                                    </div>
                                </div>
                            </div>

                            <div class="item">
                                <div class="l-title">
                                    <p>2、CAVE方式</p>
                                </div>
                                <img src="../img/j3.png" alt="">
                                <p> 实训室采用环屏3D立体虚拟现实交互技术，通过佩戴3D眼镜支持多用户共享交互的虚拟仿真环境呈现系统，不同于一般的虚拟环境，它既能够给用户提供超大范围视野的高分辨率、高质量立体影像，同时系统在不同交互设备的支持下，适配各类交互程序和交互方式，结合实际空间搭建的环形屏幕，营造大视野虚拟沉浸空间，提供给用户一种前所未有的沉浸感。可实现单人、多人协同训练、示教展示，支持多形式的多人同时在虚拟现实的环境中进行团队协同模拟演练。
                                    该系统支持多人观看交互操作，学生需要戴3D眼镜，可交互操作；结合动作捕捉技术，虚拟物品跟随视野运动并可以交互。可满足多人同时查看。
                                    具体为操作者佩戴主动式3D眼镜以及跟踪单元，观看软件呈现的生动逼真的3D效果，通过手势传感器直接利用抓、握、捏等手势抓取3D对象，多个角度旋转观察，更清晰直观，也可直接通过手势切换下一操作步骤，同时头部跟踪会对人的位置进行定位，实时移动场景，非常方便快捷。
                                </p>
                            </div>
                        </div>
                        <div v-show="childrenIndex == 2" class="programme">
                            <div class="item">
                                <div class="l-title">
                                    <p>1、CAVE沉浸式虚拟现实显示系统</p>
                                </div>
                                <img src="../img/f1.png" alt="">
                                <p>CAVE，英文全称CAVE Automatic Virtual
                                    Environment，中文译为“洞穴状自动统”CAVE沉浸式虚拟现实显示系统是一种基于多通道视景同步技术、三维空间整形校正算法、立体显示技术的房间式可视协同环境，可提供一个同房间大小的四面（或六面）立方体投影显示空间，供多人参与，所有参与者均完全沉浸在一个被三维立体投影画面包围的高级虚拟仿真环境中，借助相应虚拟现实交互设备（如数据手套、力反馈装置、位置跟踪器等），从而获得一种身临其境的高分辨率三维立体视听影像和6自由度交互感受。由于投影面几能够覆盖用户的所有视野,所以CAVE系统能提供给使用者一种前所未有的带有震撼性的身临其境的沉浸感。
                                </p>
                            </div>
                            <div class="item">
                                <div class="l-title">
                                    <p>2、大空间互动方案</p>
                                </div>
                                <img src="../img/f2.png" alt="">
                                <p> 以动作捕捉和定位技术为交互入口，智能3D立体交互系统为界面，以高校各学科教学需求及定制开发的教学课件内容为载体，形成以教为主的虚拟现实人机交互系统。结合以协同实训为补充的VR大空间多人交互的虚拟实训系统，为职校高校各学科VR实训室建设提供富有创新性的虚拟现实场景化教学整体应用方案。
                                </p>
                            </div>
                        </div>
                    </div> 
                    智慧教室
                    <div v-show="tabIndex == 2" class="school">
                        <div class="item">
                            <div class="l-title">
                                <p>大空间多人互动实训室</p>
                            </div>
                            <p>大空间多人互动实验室能让学生感受到所学的学科知识真实在线，这种沉浸式学习能与所学内容充分互动，带给学生真实体验，方便学生快速深刻了解知识点;利用多人协同软件，可以让学生与老师进入同一个场景，观看老师的讲解与互动，通过学生间互动联系，可以快速建立项目默契感加深合作基础。
                            </p>
                            <div class="list">
                                <div class="li" v-for="i in 9" :key="i">
                                    <div class="img">
                                        <img :src="`../img/zb${i}.png`" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="l-title">
                                <p>LED沉浸式CAVE虚拟现实实验室</p>
                            </div>
                            <p>LED沉浸式CAVE虚拟现实实验室是主流虚拟仿真实验室，可以可视化教学内容，人机跟踪交互，立体显示的一体化系统支撑平台。CAVE系统可真实体验书本中的知识点，采用更为创新的呈现以带领学生进入虚拟环境，方式带来感官沉浸式体验，能更好的展现因为时空限制或者抽象而来的实物或者场景。
                            </p>
                        </div>
                        <div class="item">
                            <div class="l-title">
                                <p>理实一体化智慧教学平台</p>
                            </div>
                            <p>理实一体化智慧教学解决方案是以项目引导、任务驱动为依托，运用先进的教育技术、教学手段、教学方法和多元评价体系，基于智慧实训平台搭配智慧实训设备，可覆盖实训教学全环节，打造多专业覆盖，多角色管理，多模式教学，多维度数据的5G理实一体化实训解决方案。
                            </p>
                            <div class="list">
                                <div class="li" v-for="(e, i) in teachingList" :key="i">
                                    <div class="img">
                                        <img :src="`../img/${e.img}`" alt="">
                                    </div>
                                    <p>{{ e.name }}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                    融媒体直播
                    <div v-show="tabIndex == 3" class="live_broadcast">
                        <div class="item">
                            <div class="l-title">
                                <p>融媒体直播服务简介</p>
                            </div>
                            <p>公司拥有专业的直播服务团队和设备，可为用户提供全直播服务的咨询、建议和覆盖整个直播服务周期的品质监控工作。围绕用户不同层次的需求开展六大核心服务一一视频直播、云摄像照片直播、短视频直播、视频制作和回放、云会议直播、直播全网分发推广。
                            </p>
                        </div>
                        <div class="item">
                            <div class="l-title">
                                <p>直播服务场景</p>
                            </div>
                            <div class="list">
                                <div class="li" v-for="e in broadcastList" :key="e">
                                    <div class="img">
                                        <img :src="`../img/${e.img}`" alt="">
                                    </div>
                                    <p>{{ e.name }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="l-title">
                                <p>直播服务流程</p>
                            </div>
                            <div class="flow">
                                <div class="box" v-for="(e, i) in flowpathList" :key="e.id">
                                    <div class="icon">
                                        <img :src="`../img/${e.img}`" alt="">
                                    </div>
                                    <p>{{ i + 1 }}、{{ e.name }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="l-title">
                                <p>团队拍摄</p>
                            </div>
                            <div class="team">
                                <img src="../img/ps.png" alt="">
                                <div class="data">
                                    <div class="box" v-for="e in teamList" :key="e">
                                        <p>{{ e.name }}</p>
                                        <span>设备：{{ e.device }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  -->
                
            </div>
            <FootCommon></FootCommon>
        </div>
    </div>
</template>
  
<script>
import HeadCommon from '@/components/HeadCommon.vue'
import FootCommon from '@/components/FootCommon.vue'
import { getIndustry, getIndustryList, getIndustryListPageInfo } from "@/api/product";
export default {
    name: 'ProductS',
    components: {
        HeadCommon,
        FootCommon
    },
    data() {
        return {
            tabIndex: 0, // 初始展开的父级菜单索引
            childrenIndex: null, // 初始选中的子菜单索引
            tabList: [
                {
                    id: '',
                    title: '',
                    before_id: '',
                    type: '',
                    list: [
                    ],
                }

            ],
            PageInfoList: [],
            name: '',
            article: '',
            id: '',
            type: ''
        }
    },
    created() {
        this.$nextTick(() => {
            this.getIndustry();
        });
    },
    mounted() {
        this.$nextTick(() => {
            this.getIndustry();
        });
    },
    methods: {
        // 获取父级菜单数据
        async getIndustry() {
            //父级菜单
            const { data } = await getIndustry();
            // console.log(data, 888);
            this.tabList = data;
            this.tabList.type = data[0].type
            console.log(data[0].type, 156324);
            const firstId = this.tabList[0].id
            // console.log(firstId,"第一个父级");
            const firstIndex = 0;
            this.toggleSubMenu(firstIndex, firstId)
        },
        //显示子菜单
        async toggleSubMenu(index, id) {
            const { data } = await getIndustryList(id);
            // console.log(id, '父级id');
            console.log(data, 123456);
            this.tabList.list = data;
            // 切换父级菜单的可见性，即选择不同的父级菜单项时，展示相应的子级菜单
            if (this.tabIndex === index) {
                this.childrenIndex = 0; // 如果点击已选中的菜单，则关闭子菜单
            } else {
                this.tabIndex = index;
                this.childrenIndex = 0;
            }
            this.$nextTick(() => {
                const codeContainer = document.querySelector('.children');
                const firstChild = codeContainer.firstElementChild;
                if (firstChild) {
                    // 创建一个点击事件
                    const clickEvent = new Event('click', {
                        bubbles: true, // 允许事件冒泡
                        cancelable: true // 允许事件取消
                    });
                    // 触发点击事件
                    firstChild.dispatchEvent(clickEvent);
                } else {
                    getIndustryListPageInfo(id, this.type)
                        .then(response => {
                            const { data } = response;
                            // 处理获取到的数据
                            // console.log(data, 555); 
                            this.PageInfoList = data
                            // 详情相关的右侧界面
                            this.name = data.name
                            this.article = data.article
                        })
                        .catch(error => {
                            console.error("获取数据时出错", error);
                            // 在这里处理错误，例如显示错误消息给用户
                        });
                }
            });

        },
        // 子菜单的点击事件
        async selectChild(index, id, type) {
            this.type = type
            console.log(this.type, 4444);
            this.childrenIndex = index; // 选择子菜单时更新
            const { data } = await getIndustryListPageInfo(id)
            // console.log(id,9999999);
            console.log(data, 555);
            this.$store.state.pageId = data.id
            console.log(this.$store.state.pageId, "vuex");
            // 列表相关的右侧界面
            this.PageInfoList = data
            // 详情相关的右侧界面
            this.name = data.name
            this.article = data.article
        },
        //列表详情的点击事件
        async getIndustryListInfo(id) {
            console.log(id, 456789);
            // this.$store.state.pageId = id
            // console.log(this.$store.state.pageId,"vuex");
            this.$router.push({ name: 'ListDetails', params: { id } });
            // this.$router.push('/listdetails/:id')
        }

    },


}

</script>
  
<style scoped>@import '../style/product.css';</style>